/* eslint-disable @typescript-eslint/naming-convention */
import { Injectable } from '@angular/core';
// import { AngularFireAuth } from '@angular/fire/auth';
//import { GooglePlus } from '@awesome-cordova-plugins/google-plus/ngx';
import { Platform } from '@ionic/angular';
// import firebase from 'firebase/app';
import 'firebase/auth';
import { BehaviorSubject } from 'rxjs';
import { APP_CONSTANTS } from 'src/constants/constants';
import { BoxxOAuthTemplateMethod } from '../classes/OAuthTemplateMethod';
import { BoxxOAuthResponseProps } from '../contracts/IBoxxOAuth';

declare const gapi: any;
let auth2: any;

@Injectable({
  providedIn: 'root', //<-- in order to be a singleton
})
export class BoxxGoogleOAuthService extends BoxxOAuthTemplateMethod {
  //private readonly provider = new firebase.auth.GoogleAuthProvider();

  constructor(
    private platform: Platform,
    //private googlePlus: GooglePlus,
    //private fireAuth: AngularFireAuth
  ) {
    super(platform);
  }

  getProvider() {
    //return this.provider;
  }

  async nativeOAuth(params: GPlusOAuthParmsProps = {}): Promise<IGoogleOAuthResponse> {
    return null;
    // try {
    //   const oauthResponse = (await this.googlePlus.login({
    //     ...params,
    //     webClientId: APP_CONSTANTS.gcpWebClientId,
    //   })) as IGPlusPluginOAuthResponse;

    //   const response: IGoogleOAuthResponse = {
    //     authResponse: {
    //       accessToken: oauthResponse.accessToken,
    //       userID: oauthResponse.userId,
    //     },
    //     profileResponse: {
    //       firstName: oauthResponse.givenName,
    //       lastName: oauthResponse.familyName,
    //       email: oauthResponse.email,
    //     },
    //   };

    //   return response;
    // } catch (e) {
    //   console.error('gPlusNativeOAuth()', e);
    //   this.manageOAuthError(e);
    // }
  }

  async webOAuth(): Promise<BoxxOAuthResponseProps> {
    try {
      return null;
      //const oauthResponse = await this.fireAuth.signInWithPopup(this.provider);

      // const profile = {
      //   ...oauthResponse.additionalUserInfo.profile,
      // } as gPlusProfile;

      // const response: IGoogleOAuthResponse = {
      //   authResponse: {
      //     accessToken: (oauthResponse.credential as any).accessToken,
      //     userID: profile.id,
      //   },
      //   profileResponse: {
      //     firstName: profile.given_name,
      //     lastName: profile.family_name,
      //     email: profile.email,
      //   },
      // };

      // return response;
    } catch (e) {
      console.error('gplusWebOAuth()', e);
      this.manageOAuthError(e);
    }
  }
}

export interface IGPlusPluginOAuthResponse {
  accessToken: string;
  displayName: string; //fullname
  email: string;
  expires: number;
  expires_in: number;
  familyName: string; //last name(s)
  givenName: string; //name
  idToken: string;
  imageUrl: string;
  userId: string;
}

export interface IGoogleOAuthResponse extends BoxxOAuthResponseProps {
  authResponse: {
    accessToken: string;
    userID: string;
    code?: string;
  };
  profileResponse: {
    email: string;
    firstName: string;
    lastName: string;
    imageUrl?: string;
  };
}

export interface gPlusProfile {
  email?: string;
  family_name?: string;
  given_name?: string;
  granted_scopes?: string;
  hd?: string;
  id?: string;
  locale?: string;
  name?: string;
  picture?: string;
  verified_email?: boolean;
}

export interface GPlusOAuthParmsProps {
  scopes?: string;
  offline?: boolean;
  responseType?: 'code';
}
